import { useState } from 'react';

import { Button, type ButtonProps } from '@mui/material';
import { Plus } from 'lucide-react';

import { CreateTransactionStepper } from '@modules/_shared/components/create-transaction/CreateTransactionStepper';
import { Drawer } from '@modules/_shared/components/drawer/Drawer';
import { useLocale } from '@shared/hooks/locale';

type AddTransactionButtonProps = Omit<ButtonProps, 'onClick'>;

export const AddTransactionButton = (props: AddTransactionButtonProps) => {
  const { t } = useLocale();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="soft"
        fullWidth
        startIcon={<Plus />}
        {...props}
        onClick={() => setOpen(true)}
      >
        {t('Add transaction')}
      </Button>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        title={t('Add transaction')}
        maxWidth={900}
      >
        <CreateTransactionStepper
          onTransactionCreated={() => {
            setOpen(false);
          }}
        />
      </Drawer>
    </>
  );
};
